
export interface TrackingEvent {
    type: 'addItemToCart'
}

export interface addItemToCartTrackingEvent extends TrackingEvent {
    type: 'addItemToCart',
    currency: string,
    total: number,
    items: TrackingEventItem[]
}

export interface TrackingEventItem {
    name: string,
    code: string,
    category: string,
    quantity: number,
    price: number
}
